import { Box, Card, CardContent, Typography } from "@mui/material";
import moment from "moment";
import AgendaEventCard from "../AgendaEventCard";

export default function AgendaDayColumn({
    date,
    events,
    view,
    darkMode,
    tipoEventoEnum,
    statusPrazoEnum,
    sistemasEnum,
    tipoPartesEnum,
    onEventClick,
}) {
    const isToday = date.isSame(moment(), "day");

    const pastelColors = {
        0: "#F8BBD0",
        1: "#B3E5FC",
        2: "#C8E6C9",
        3: "#FFE0B2",
        4: "#D1C4E9",
        5: "#FFF59D",
        6: "#FFCCBC",
    };

    const dayOfWeek = date.day();

    const darkModePastel = (hex) => `${hex}ab`;

    const dayCardBg = isToday
        ? darkMode
            ? "#0d47a1"
            : "#E3F2FD"
        : darkMode
            ? darkModePastel(pastelColors[dayOfWeek])
            : pastelColors[dayOfWeek];

    const textColor = darkMode ? "#fff" : "#000";
    const secondaryTextColor = darkMode ? "#ffffffff" : "text.secondary";

    return (
        <Card
            variant="outlined"
            sx={{
                height: view === "month" ? 220 : "calc(100vh - 315px)",
                backgroundColor: dayCardBg,
                borderRadius: 2,
                overflowY: "auto",
                borderColor: isToday
                    ? darkMode
                        ? "#90CAF9"
                        : "#0f4e8d63"
                    : darkMode
                        ? "#333"
                        : "#ddd",
                borderWidth: 1,
                boxShadow: isToday
                    ? darkMode
                        ? "0 0 8px rgba(144, 202, 249, 0.4)"
                        : "0 0 6px rgba(25, 118, 210, 0.3)"
                    : "none",
                transition: "all 0.2s ease-in-out",

                "&::-webkit-scrollbar": { width: "6px" },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: darkMode ? "#2a2a3f" : "#f0f0f0",
                    borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: darkMode ? "#90CAF9" : "#90A4AE",
                    borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: darkMode ? "#64B5F6" : "#78909C",
                },
                scrollbarWidth: "thin",
                scrollbarColor: darkMode
                    ? "#90CAF9 #2a2a3f"
                    : "#90A4AE #f0f0f0",
            }}
        >
            <CardContent sx={{ p: 1 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography
                        variant="caption"
                        sx={{ fontWeight: "bold", color: secondaryTextColor }}
                    >
                        {date.format("ddd")}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold", color: textColor }}
                    >
                        {date.date()}
                    </Typography>
                </Box>

                {events.map((evento) => (
                    <AgendaEventCard
                        key={evento.id}
                        evento={evento}
                        darkMode={darkMode}
                        tipoEventoEnum={tipoEventoEnum}
                        statusPrazoEnum={statusPrazoEnum}
                        sistemasEnum={sistemasEnum}
                        tipoPartesEnum={tipoPartesEnum}
                        onClick={onEventClick}
                    />
                ))}
            </CardContent>
        </Card>
    );
}
